export default __webpack_public_path__ + "static/media/backgroundEpm.209df49f.jpg";